import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMapPin } = FiIcons;

const SpaCard = ({ spa }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-white rounded-[2rem] overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 border border-stone-200 group flex flex-col h-full"
    >
      <div className="relative h-64 overflow-hidden">
        <img 
          src={spa.imageUrl} 
          alt={spa.name} 
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 ease-out"
        />
        <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl text-[10px] font-black text-indigo-900 shadow-xl uppercase tracking-[0.2em]">
          {spa.type}
        </div>
      </div>
      
      <div className="p-8 flex flex-col flex-grow">
        <div className="mb-6">
          <h3 className="font-playfair text-3xl font-bold text-stone-900 mb-3 group-hover:text-indigo-800 transition-colors leading-tight">
            {spa.name}
          </h3>
          <div className="flex items-center text-stone-400 text-sm font-bold uppercase tracking-widest">
            <SafeIcon icon={FiMapPin} className="w-4 h-4 mr-2 text-indigo-400" />
            <span>{spa.neighborhood}</span>
          </div>
        </div>
        
        <p className="text-stone-600 text-lg mb-8 line-clamp-2 leading-relaxed flex-grow">
          {spa.description}
        </p>
        
        <div className="flex flex-wrap gap-2 mb-8">
          {spa.features.slice(0, 3).map((feature, idx) => (
            <span key={idx} className="bg-stone-50 text-stone-500 text-xs font-bold px-4 py-2 rounded-xl border border-stone-100">
              {feature}
            </span>
          ))}
        </div>
        
        <div className="mt-auto pt-8 border-t border-stone-100 flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-[10px] font-black text-stone-400 uppercase tracking-widest">From</span>
            <span className="text-2xl font-black text-stone-900">${spa.services[0]?.price || '50'}</span>
          </div>
          <Link 
            to={`/spa/${spa.id}`}
            className="bg-stone-900 text-white px-8 py-4 rounded-2xl font-bold text-sm hover:bg-indigo-900 transition-all shadow-lg hover:shadow-indigo-900/20"
          >
            View Details
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default SpaCard;